import React, {Component} from "react";
import ReactTable from "react-table";
import {Row} from "react-bootstrap";
import Footer from "../layout/Footer";
import {
    getErrorMessagesFromCode,
    getErrorMsgFromStatus,
    getSuccessMessages
} from "../../lib/messageHandler";
import {API} from "../../lib/API";
import localStorage from "../../lib/localStorage";
import {withTranslation} from "react-i18next";
import KnoaToggle from "../common/KnoaToggle";

class UrlsContainer extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.renderEditable = this.renderEditable.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleToggleChange = this.handleToggleChange.bind(this);
        this.updateCurrentMapping = this.updateCurrentMapping.bind(this);

        this.state = {
            currentMapping: JSON.parse(JSON.stringify(this.props.allMappings)),
            editMode: false,
            formErrors: {}
        }
    }

    generateData = (mappings) => {
        return mappings.map(mapping => {
            let urlMappingList = [];
            urlMappingList.push(mapping.id);
            urlMappingList.push(mapping.url);
            urlMappingList.push(mapping.name);
            urlMappingList.push(mapping.category);
            urlMappingList.push(mapping.appLevel);
            urlMappingList.push(mapping.pageLevel);
            urlMappingList.push(mapping.users);
            return urlMappingList
        });
    };

    updateCurrentMapping(id, property, value) {
        let _currentMapping = JSON.parse(JSON.stringify(this.state.currentMapping));
        for(const key in _currentMapping) {
            if(_currentMapping[key].id===id) {
                _currentMapping[key][property] = value;

                if(JSON.stringify(_currentMapping[key][property]) !== JSON.stringify(this.state.currentMapping[key][property])) {
                    this.setState({currentMapping: _currentMapping})
                }

                break;
            }
        }
    }

    handleEdit(evt) {
        let _value = evt.target.checked;
        if(_value !== undefined) {
            this.setState({
                editMode: _value
            });
        }
    }

    renderEditable(cellInfo) {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const _data = e.target.id.split(":");
                    const _id = parseInt(_data[0]);
                    const _property = _data[1];
                    const _value = e.target.innerHTML;
                    this.updateCurrentMapping(_id, _property, _value)
                }}
                dangerouslySetInnerHTML={{
                    __html: cellInfo.value.props.children
                }}
                id={cellInfo.value.props.id}
            />
        );
    }

    handleToggleChange(evt, idVal) {
        let _value = evt.target.checked;
        if(_value !== undefined) {
            const _data = idVal.split(":");
            const _id = parseInt(_data[0]);
            const _property = _data[1];
            this.updateCurrentMapping(_id, _property, _value)
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const _this = this;
        this.setState({fetchInProgress: "true"});

        const mappingToSave = {
            mappings: this.state.currentMapping
        };

        API.admin
        .post(`/admin/gtm/configuration/app/mapping`, mappingToSave)
        .then(resp => {
            const {data: resData} = resp;
            let inSupport = resData ? resData.inSupport : false;
            _this.props.handleAlertClick("success", "tc", getSuccessMessages(_this.props.t,'gtmSaved', null), inSupport);
            console.log(`configuration saved! \n` + JSON.stringify(_this.state.currentMapping));
            _this.setState({fetchInProgress: localStorage.get("isLoading")});
            _this.props.updateAllMappings(_this.state.currentMapping);
        })
        .catch(e => {
            console.error(e);
            _this.setState({fetchInProgress: localStorage.get("isLoading")});
            if(localStorage.get("accessDenied401") === "true"){
                _this.setState({showLoggedoutModal:true});
                return;
            }

            let resultCode = -1;
            if(e.data) {
                resultCode = e.data.resultCode;
            }
            if (e.status === 401 || resultCode === 6007)
                window.location.href = "/#/auth/logout";

            if (resultCode > -1)
                _this.props.handleAlertClick("error", "tc", getErrorMessagesFromCode(_this.props.t, resultCode, true));
            else
                _this.props.handleAlertClick("error", "tc", getErrorMsgFromStatus(_this.props.t, e, true));
        });
    }

    render() {
        const {t} = this.props;
        const dataTable = this.generateData(this.state.currentMapping);
        const defaultPageSize = dataTable.length === 0 ? 5 : 50;
        const footerObj = [];
        const updatePreferencesObj = {
            name: t("common:save"),
            callback: this.handleSubmit,
            disabled: JSON.stringify(this.state.currentMapping) === JSON.stringify(this.props.allMappings)
        };
        footerObj.push(updatePreferencesObj);

        return (
            <>
            <div className="card">
                <div className="content">
                    <div className="NavBar-btn-container">
                        <label id="editSwitch"
                               className="switchLabel"
                               htmlFor="editMode"
                        >
                            {"Edit"}
                        </label>
                        <KnoaToggle Name="editMode"
                                    onChange={this.handleEdit}
                                    value={this.state.editMode}
                                    labelId={"editSwitch"}
                                    onText={t('common:ON')}
                                    offText={t('common:OFF')}
                        />
                    </div>
                    <form onSubmit={this.handleSubmit} noValidate>
                        <div className="panel-body">
                            <Row className="users-table-header">
                                <h4 className="card-title">{this.props.title}</h4>
                            </Row>
                            <Row className="users-table-header">
                                <span className="knoaCardCategory">{t('gtm:titleStatsOf1')}
                                    <span style={{color:'red'}}>{this.props.discovered}</span>
                                    {t('gtm:titleStatsOf2')}
                                    <span style={{color:'red'}}>{this.state.currentMapping.length.toString()}</span>
                                    {t('gtm:titleStatsOf3')}
                                </span>
                            </Row>
                            <div className="knoa-region" tabIndex={"-1"}>
                                <ReactTable
                                    getTheadThProps={(state, rowInfo, column, instance) => {
                                        // Check if the column is sortable before applying sorting attributes
                                        if (!column.sortable) {
                                            return {
                                                tabIndex: "-1", // Exclude non-sortable headers from keyboard focus
                                            };
                                        }

                                        const sortedColumn = instance.state.sorted.find((sort) => sort.id === column.id);
                                        const isSorted = Boolean(sortedColumn);
                                        const isSortedDesc = sortedColumn?.desc;

                                        return {
                                            tabIndex: "0",
                                            onKeyPress: (event) => {
                                                if (event.key === "Enter" || event.key === " ") {
                                                    instance.sortColumn(column);
                                                }
                                            },
                                            "aria-label": `Sort by ${column.Header}`,
                                            "aria-sort": isSorted ? (isSortedDesc ? "descending" : "ascending") : "none"
                                        };
                                    }}
                                    defaultSortMethod={ (a, b) => {
                                        if(a.props.children.props) {
                                            a = a.props.children.props.value;
                                            b = b.props.children.props.value;
                                        } else {
                                            a = a.props.children;
                                            b = b.props.children;
                                        }
                                        // force null and undefined to the bottom
                                        a = a === null || a === undefined ? -Infinity : a;
                                        b = b === null || b === undefined ? -Infinity : b;
                                        // force any string values to lowercase
                                        a = typeof a === 'string' ? a.toLowerCase() : a;
                                        b = typeof b === 'string' ? b.toLowerCase() : b;
                                        // Return either 1 or -1 to indicate a sort priority
                                        if (a > b) {
                                            return 1
                                        }
                                        if (a < b) {
                                            return -1
                                        }
                                        // returning 0 or undefined will use any subsequent column sorting methods or the row index as a tiebreaker
                                        return 0
                                    }}
                                    defaultFilterMethod={
                                        (filter, row, column) => {
                                            const id = filter.pivotId || filter.id
                                            return row[id] !== undefined ? String(row[id].props.children).toLowerCase().includes(filter.value.toLowerCase()) : true
                                        }
                                    }
                                    columns={[
                                        {
                                            Header: t('gtm:domain'),
                                            accessor: "url",
                                            maxWidth: 300,
                                            sortable: true,
                                            filterable: true
                                        },
                                        {
                                            Header: t('gtm:applicationName'),
                                            accessor: "name",
                                            maxWidth: 300,
                                            sortable: true,
                                            filterable: true,
                                            Cell: this.state.editMode ? this.renderEditable : null,
                                        },
                                        {
                                            Header: t('gtm:applicationCategory'),
                                            accessor: "category",
                                            maxWidth: 300,
                                            sortable: true,
                                            filterable: true,
                                            Cell: this.state.editMode ? this.renderEditable : null,
                                        },
                                        {
                                            Header: t('gtm:enableMonitoring'),
                                            headerStyle: {textAlign:'center'},
                                            accessor: "appLevel",
                                            sortable: true,
                                            maxWidth: 150
                                        },
                                        {
                                            Header: t('gtm:uniqueUsers'),
                                            headerStyle: {textAlign:'center'},
                                            accessor: "users",
                                            sortable: true,
                                            maxWidth: 150
                                        }
                                    ]}
                                    data={
                                        dataTable.map((prop, key) => {
                                            return ({
                                                id: prop[0],
                                                url: <span id={prop[0]+':url'}>{prop[1]}</span>,
                                                name: <span id={prop[0]+':name'}>{prop[2]}</span>,
                                                category: <span id={prop[0]+':category'}>{prop[3]}</span>,
                                                appLevel: (
                                                    <div className="centerContainer">
                                                        <KnoaToggle Name={prop[0]+':appLevel'}
                                                                    onChange={(event) => this.handleToggleChange(event,prop[0]+':appLevel')}
                                                                    value={prop[4]}
                                                                    labelId={prop[0]+':appLevel'}
                                                                    disabled={!this.state.editMode}
                                                                    onText={t('common:yes')}
                                                                    offText={t('common:no')}
                                                        />
                                                    </div>
                                                ),
                                                users: <div className="centerContainer">{prop[6]}</div>
                                            })
                                        })
                                    }
                                    defaultSorted={[
                                        {
                                            id: "users",
                                            desc: true
                                        }
                                    ]}
                                    filterable={false}
                                    defaultPageSize={defaultPageSize}
                                    pageSizeOptions={[25, 50, 100]}
                                    showPagination
                                    showPaginationTop={false}
                                    showPaginationBottom={dataTable.length>0}
                                    showPageSizeOptions={true}
                                    className="-highlight"
                                    getPaginationProps={(a) => {
                                        return {
                                            style: {
                                                fontSize: '12px',
                                                width: '600px'
                                            }
                                        }
                                    }}
                                    previousText={t('common:previous')}
                                    nextText={t('common:next')}
                                    pageText={t('common:page')}
                                    ofText={t('common:of')}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Footer fluid footerObj={footerObj}/>
            </>
        );
    }
}

export default withTranslation()(UrlsContainer);